import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../components/SeoHead';
import MainBanner from '../../../components/MainBanner';
import GetInTouch from '../../../components/GetInTouch';
import MultiColumnCTAWithDivider from '../../../components/MultiColumnCTAWithDivider';

export default function ContactUsPage({
    global,
    all_branches
}) {
    return (
        <>
            <SeoHead
                page_name={`Contact Us | Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG | United States`}
                canonical_link={`contact-us`}
                en_gb={false}
                en_us={true}
            />
            <MainBanner
                global={global}
                pathPrefix={`us.contact_us_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Contact Us</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
            />
            <GetInTouch
                global={global}
                pathPrefix={`us.contact_us_page.get_in_touch`}
                customClass={`py-5 grayGradientBg`}
                formId={"7bd76c88-67ad-40d8-b129-63a4cf07c696"}
                content={
                    <>
                        <h2>Get in Touch!</h2>
                        <p>There are many way to get in touch.</p>
                    </>
                }
                content_2={
                    <>
                        <h3>
                            Send Us Your CV/Resume
                        </h3>
                    </>
                }
                buttonLink={`/us/contact-us/`}
                buttonTitle={`Submit your CV/Resume`}
                popUpModal_1={true}
                popUpModal_1_form_id={`05bfd90b-f572-40f9-a5d2-00de82f93e81`}
                dialog_content_1={
                    <>
                        <h5>Submit your CV/Resume</h5>
                    </>
                }
                post={all_branches}
                successPageUrl={`/us/contact-us/submission-success`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    const branches = await Collection('branches_us');

    const all_branches = branches.orderBy('_order').getItems();
    return {
        props: {
            global,
            all_branches
        }
    };
}
